import dayjs from 'dayjs'
import Vue from 'vue'

const mutations = {
    setAddedNotification(state, { type, message }) {
        if (Object.keys(state).indexOf(type) < 0) {
            type = 'info'
        }
        state[type].push({ timestamp: dayjs(), message: message })
    },

    setInterfaceMessages(state, { list }) {
        Vue.set(state, 'interfaceMessages', list)
    }
}

export default mutations
